import { serializeLicitacoesQuery } from '@/utils/licitacoesFiltersQuery';
import { api } from './http';

export const pesquisar = (filters = {}, { cadastradas = false } = {}) => {
  const params = serializeLicitacoesQuery(filters);
  if (cadastradas) params.cadastradas = true;
  return api.get('/ofertascompra', { params });
};

export default pesquisar;
